var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  stroke: "currentColor"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes spinner_zKoa{to{transform:rotate(360deg)}}@keyframes spinner_YpZS{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,to{stroke-dasharray:42 150;stroke-dashoffset:-59}}")), /*#__PURE__*/React.createElement("g", {
  style: {
    transformOrigin: "center",
    animation: "spinner_zKoa 2s linear infinite"
  }
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 8.5,
  fill: "none",
  strokeWidth: 2.5,
  style: {
    strokeLinecap: "round",
    animation: "spinner_YpZS 1.5s ease-in-out infinite"
  }
})));
export default SvgSpinner20;